/* eslint-disable complexity */
/* eslint-disable require-jsdoc */
(function() {
  var ariaDisabled = 'aria-disabled',
      addtocartButton = 'addtocartButton',
      decisionpageCards = 'decisionpageCards',
      decisionpageitem = 'decisionpageitem',
      prodSearchName = 'ph-prodSearchName',
      atpMessage = 'ph-atpmessage',
      isOneStore = $('.ph-isOneStore').html(),
      finalPricePcmsClass = '.ph-final-price-pcms',
      finalPriceHhsClass = '.ph-final-price-hhs',
      featureFinalPricePcmsClass = '.ph-featurefinalprice-pcms',
      featureFinalPriceHhsClass = '.ph-featurefinalprice-hhs',
      productOutOfStockClass = '.ph-product__outofstock',
      componentproductlist = '.ph-componentproductlist',
      atpMsgDiv = '.ph-atpmsgdiv';

  function ajaxHhsPcms($this, result) {
    var $othis = $this;

    if (result.wishListName !== null && result.wishListName !== '') {
      var wishListNames = result.wishListName,
          wishListUrl = '';

      wishListUrl = wishListNames.split(' ').join('');

      $othis.find('.ph-loader').removeClass('hidden');
      $othis.find('.ph-whislist__parent').removeClass('hidden');
      $othis.find('.ph-wishlistname').html(wishListNames);
      $othis.find('.ph-wishlistname').attr('title', wishListNames);
      $othis.find('.ph-wishlistname').attr('href', '/shoppingList#' + wishListUrl);
    }
  }

  function configurableProductCondition($othis, result) {
    var addToCartBtn = $othis.find('.' + addtocartButton),
        outOfStockMsg = $othis.find(productOutOfStockClass);

    if (addToCartBtn.attr('data-istransducer') === 'true') {
      addToCartBtn.prop('type', 'button');
      addToCartBtn.addClass('ph-lumifyconfigurelink');
    }

    if ($('#productOutofstock_' + result.code).attr('isConfigurableProduct') === 'true') {
      outOfStockMsg.removeClass('hidden');
      $othis.find('.ph-price').addClass('hidden');
      $othis.find('form .ph-addtocart_animation .' + addtocartButton).attr('type', 'button');
    }
  }

  function setRenderButtonSubFunction($this, result) {
    var outOfStockMsg = $this.find(productOutOfStockClass);

    outOfStockMsg.addClass('hidden');
    $this.find('.' + atpMessage).removeClass('hidden');
    $this.find('.ph-loader').addClass('hidden');
    $this.find('.' + addtocartButton).removeClass('hidden');
    $this.find('.' + addtocartButton).attr('disabled', false);
    $this.find('.' + addtocartButton).removeClass('out-of-stock ph-disabledbutton');
    $this.find('.' + addtocartButton).prop('type', 'submit');
    $this.find('.' + addtocartButton).attr(ariaDisabled, false);

    configurableProductCondition($this, result);
    ACC.pdp.igtdMessageDisplay(result.code);
  }

  function renderButton($othis, result, isSubmit) {
    var addToCartBtn = $othis.find('.' + addtocartButton),
        outOfStockMsg = $othis.find(productOutOfStockClass),
        isSubmitValue = isSubmit;

    if ($(document).find('.isRseUser').text() === 'true') {
      isSubmitValue = false;
    }

    if (isSubmitValue) {
      $othis.find('.ph-price').removeClass('hidden');
      setRenderButtonSubFunction($othis, result);
    } else {
      $othis.find('.ph-loader').addClass('hidden');

      if (result.approval !== 'regulatoryonhold' && result.approval !== 'obsolete') {
        $othis.find('.ph-price').addClass('hidden');
      }

      addToCartBtn.removeClass('hidden');
      addToCartBtn.attr('disabled', true);
      addToCartBtn.addClass('out-of-stock ph-disabledbutton ph-inactive');
      addToCartBtn.prop('type', 'button');
      addToCartBtn.attr(ariaDisabled, true);
      // For obsolete products, outOfStockMsg will contain obsolete message (as text content is decided in productListerItem.tag)
      outOfStockMsg.removeClass('hidden');
      $othis.find('.' + atpMessage).addClass('hidden');
    }
  }

  function lazyLoadListingPage() {
    $('.prod_list').each(function() {
      var currentCtn = $(this).find('.' + prodSearchName).attr('data-prod'),
          isSpProduct = $(this).closest('.ph-decisionpage__item').find('.ph-product-isSpProduct').val(),
          $othis = $(this);

      ACC.decisionPageInfiniteLoader.sparepartRibbonCheck($(this));

      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/lazyload/getpricedata',
        dataType: 'json',
        data: {
          code: currentCtn,
          isSparePart: isSpProduct
        },
        success: function(result) {
          var havePrice = false;

          if (isSpProduct === 'true') {
            if (result.price !== null) {
              havePrice = ACC.decisionPageInfiniteLoader.setPriceDetails($othis, result);
            }

            renderButton($othis, result, havePrice);
          } else if (String(result.isLumifyProduct) !== 'true' && $('#productOutofstock_' + result.code).attr('isConfigurableProduct') === 'true') {
            renderButton($othis, result, true);
          } else {
            if (result.price !== null) {
              havePrice = ACC.decisionPageInfiniteLoader.setPriceDetails($othis, result);
            }

            renderButton($othis, result, havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved');
          }

          ajaxHhsPcms($othis, result);
        }
      });
    });
  }

  function estDeliveryHhsResultDate(resultData) {
    var estDelHhsDate = resultData,
        deliveryDateValue = '',
        instockDeliveryRange = String($('.ph-atpvar-instockDeliveryRange').text()),
        outofstockMessage = $('.ph-outofstock-message').text();

    if (String(estDelHhsDate.philipsATPData) !== 'null' && String(estDelHhsDate.philipsATPData.isProductInStock) === 'true') {
      if (estDelHhsDate.philipsATPData.estimateDeliveryDate !== null && estDelHhsDate.philipsATPData.estimateDeliveryDate !== '') {
        deliveryDateValue = instockDeliveryRange + '&nbsp;&nbsp;' + estDelHhsDate.philipsATPData.estimateDeliveryDate;
        $('#' + decisionpageCards).find('#' + decisionpageitem + estDelHhsDate.code).find(atpMsgDiv).find('.' + atpMessage).html(deliveryDateValue);
      }
    } else if (String(estDelHhsDate.philipsATPData) !== 'null' && String(estDelHhsDate.philipsATPData.isProductInStock) === 'false') {
      $('#' + decisionpageCards).find('#' + decisionpageitem + estDelHhsDate.code).find(atpMsgDiv).find('.' + atpMessage).html(outofstockMessage);
    }
  }

  function disableAddtoCart($this) {
    $this.find('.ph-loader').addClass('hidden');

    $this.find('.' + addtocartButton).removeClass('hidden');

    $this.find('.' + addtocartButton).attr('disabled', true);
    $this.find('.' + addtocartButton).addClass('ph-disabledbutton out-of-stock ph-inactive');
    $this.find('.' + addtocartButton).prop('type', 'button');
    $this.find('.' + addtocartButton).attr(ariaDisabled, true);

    $this.find('.' + addtocartButton).removeClass('hidden');
    $this.find('.' + atpMessage).addClass('hidden');
  }

  function setButtonStatus(havePrice, thisElement, result) {
    var $this = thisElement,
        outOfStockMsg = $this.find(productOutOfStockClass);

    if (havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
      estDeliveryHhsResultDate(result);
      $this.find('.p-value').removeClass('hidden');
      $this.find('.ph-plp_product_leadtime').removeClass('hidden');

      if ($(document).find('.isRseUser').text() === 'true') {
        disableAddtoCart($this);
      } else {
        setRenderButtonSubFunction($this, result);
      }
    } else {
      $this.find('.ph-loader').addClass('hidden');

      if (result.approval !== 'regulatoryonhold' && result.approval !== 'obsolete') {
        $this.find('.p-value').addClass('hidden');
      }

      $this.find('.' + addtocartButton).removeClass('hidden');

      $this.find('.' + addtocartButton).attr('disabled', true);
      $this.find('.' + addtocartButton).addClass('out-of-stock ph-disabledbutton ph-inactive');
      $this.find('.ph-qtylabeltext').addClass('hidden');
      $this.find('.' + addtocartButton).prop('type', 'button');
      $this.find('.' + addtocartButton).attr(ariaDisabled, true);

      $this.find('.' + addtocartButton).removeClass('hidden');
      // For obsolete products, outOfStockMsg will contain obsolete message (as text content is decided in productListerItem.tag)
      outOfStockMsg.removeClass('hidden');
      $this.find('.' + atpMessage).addClass('hidden');
    }
  }

  function renderHhsPriceandButton(thisElement, result) {
    var $this = thisElement,
        ctn = $this.find('.' + prodSearchName).attr('data-prod'),
        finalPriceHhs = $this.find(finalPriceHhsClass),
        havePrice = false;

    if (isOneStore === 'true') {
      if ($this.find(finalPricePcmsClass).length > 0) {
        finalPriceHhs = $this.find(finalPricePcmsClass);
      }
    }

    if (result.code === ctn) {
      if ($this.find('s').length > 0 && result.price !== null && result.price.formattedFinalValue) {
        ACC.decisionPageInfiniteLoader.setStrikeoutPrice($this, result);
        finalPriceHhs.text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedFinalValue) {
        finalPriceHhs.text(result.price.formattedFinalValue);
        havePrice = true;
      } else if (result.price !== null && result.price.formattedValue) {
        finalPriceHhs.text(result.price.formattedValue);
        havePrice = true;
      }

      setButtonStatus(havePrice, $this, result);
    }
  }

  function renderPricePlp(result, substitutionClass) {
    var salesOrgValue = '',
        decisionpageitemDiv = '#' + decisionpageitem + result.code;

    if (result.salesOrg) {
      salesOrgValue = result.salesOrg;
      decisionpageitemDiv = decisionpageitemDiv + (' .prod_list[data-salesorg=' + salesOrgValue + ']');
    }

    $('#' + decisionpageCards).find(decisionpageitemDiv).each(function() {
      ajaxHhsPcms($(this), result);
      renderHhsPriceandButton($(this), result);
      ACC.pdppricelazyload.substitutionMessage($(this).find(substitutionClass), result);
    });
  }

  function priceCallResponse(results, substitutionClass, prodListClass) {
    var atpProdCodes = [];

    results.forEach(function(result) {
      if (result.price && result.price.value && result.price.value > 0) {
        atpProdCodes.push({
          prodCode: result.code,
          salesOrg: result.salesOrg
        });
        $('#decisionpageitem' + result.code).find(atpMsgDiv).removeClass('hidden');
      }

      ACC.decisionPageInfiniteLoader.handleDuplicateProdCode(result);

      renderPricePlp(result, substitutionClass);

      if ($('.yCmsComponent').find('.' + prodListClass).length > 0) {
        $('.yCmsComponent').find('.' + prodListClass).each(function() {
          renderHhsPriceandButton($(this), result);
          ACC.pdppricelazyload.substitutionMessage($(this).find(substitutionClass), result);
        });
      }

      if ($('.yCmsContentSlot').find('.' + prodListClass).length > 0) {
        $('.yCmsContentSlot').find('.' + prodListClass).each(function() {
          renderHhsPriceandButton($(this), result);
          ACC.pdppricelazyload.substitutionMessage($(this).find(substitutionClass), result);
        });
      }


      if (result.isConfigitEnabled && $('#' + decisionpageCards).length > 0) {
        ACC.configit.plpConfigitButton(result.code, result.salesOrg);
      }
    });

    if (isOneStore === 'true') {
      ACC.decisionPageInfiniteLoader.atpCallAfterPrice(atpProdCodes);
    }
  }

  function lazyLoadListingPageHhs() {
    var prodList = [],
        prodListClass = 'prod_list',
        priceUrl = '/lazyload/gethhspricedata',
        substitutionClass = '.ph-substitution',
        contentType = 'application/x-www-form-urlencoded',
        ajaxdataObj = {};

    $('.' + prodListClass).each(function() {
      var dataAttrProductId = $(this).find('.' + prodSearchName).attr('data-prod');

      ACC.decisionPageInfiniteLoader.sparepartRibbonCheck($(this));

      if (isOneStore === 'true') {
        var currObj = {
              salesOrg: ''
            },
            currObjsalesOrg = $(this).find('.' + prodSearchName).attr('data-salesorg'),
            currObjmultiSalesOrg = $(this).find('.ph-decisionpage__content').attr('data-availableinsalesorg');

        if (currObjsalesOrg) {
          currObj.salesOrg = currObjsalesOrg;
        }

        if (currObjmultiSalesOrg) {
          currObj.availableInSalesOrg = currObjmultiSalesOrg;

          var emptyimage = $(this).find('.prdimagecls').attr('data-emptyimage'),
              imgElmProd = $(this).find('.prdimagecls img'),
              currentimage = imgElmProd.attr('src');

          imgElmProd.attr('data-srcurl', currentimage);
          imgElmProd.attr('src', emptyimage);
        }

        currObj.code = dataAttrProductId;
        prodList.push(currObj);
      } else if (prodList.indexOf(dataAttrProductId) === -1) {
        prodList.push(dataAttrProductId);
      }
    });

    if (isOneStore === 'true') {
      priceUrl = '/lazyload/getPriceList';
      contentType = 'application/json';
      ajaxdataObj = JSON.stringify({
        productList: prodList
      });
    } else {
      ajaxdataObj = {
        codes: prodList.toString()
      };
    }

    $.ajax({
      type: 'POST',
      url: ACC.config.contextPath + priceUrl,
      contentType: contentType,
      data: ajaxdataObj,
      success: function(results) {
        priceCallResponse(results, substitutionClass, prodListClass);
      }
    });
  }

  function lazyLoadFeaturedProduct() {
    $(componentproductlist).each(function() {
      var currentCtn = $(this).find(prodSearchName).attr('data-ctn'),
          $othis = $(this);

      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/lazyload/getpricedata',
        dataType: 'json',
        data: {
          code: currentCtn
        },
        success: function(result) {
          var havePrice = false;

          if ($othis.find('s').length > 0 && result.price !== null && result.price.formattedFinalValue) {
            ACC.decisionPageInfiniteLoader.setStrikeoutPrice($othis, result);
            $othis.find(featureFinalPricePcmsClass).text(result.price.formattedFinalValue);
            havePrice = true;
          } else if (result.price !== null && result.price.formattedFinalValue) {
            $othis.find(featureFinalPricePcmsClass).text(result.price.formattedFinalValue);
            havePrice = true;
          } else if (result.price !== null && result.price.formattedValue) {
            $othis.find(featureFinalPricePcmsClass).text(result.price.formattedValue);
            havePrice = true;
          }

          if (havePrice && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
            $othis.find('.ph-loader').addClass('hidden');
            $othis.find('.ph-addtocart').removeClass('hidden');
            $othis.find('.ph-addtocart').attr('disabled', false);
            $othis.find('.ph-addtocart').removeClass('out-of-stock ph-disabledbutton ph-featuredproduct__outOfStock');
            $othis.find('.ph-addtocart').prop('type', 'submit');
            $othis.find('.ph-addtocart').attr(ariaDisabled, false);
            ACC.pdp.igtdMessageDisplay(result.code);
          } else {
            $othis.find('.ph-loader').addClass('hidden');

            $othis.find('.' + addtocartButton).removeClass('hidden');

            $othis.find('.ph-addtocart').removeClass('hidden');
          }
        }
      });
    });
  }

  function lazyLoadFeaturedProductHhsSubFunction(result, $this, finalPriceClass) {
    var havePrice = false;

    if ($this.find('s').length > 0 && result.price !== null && result.price.formattedFinalValue) {
      ACC.decisionPageInfiniteLoader.setStrikeoutPrice($this, result);
      $this.find(finalPriceClass).text(result.price.formattedFinalValue);
      havePrice = true;
    } else if (result.price !== null && result.price.formattedFinalValue) {
      $this.find(finalPriceClass).text(result.price.formattedFinalValue);
      havePrice = true;
    } else if (result.price !== null && result.price.formattedValue) {
      $this.find(finalPriceClass).text(result.price.formattedValue);
      havePrice = true;
    }

    if (havePrice === true && result.stock !== null && result.stock.stockLevelStatus.code !== 'outOfStock' && result.approval === 'approved') {
      $this.find('.ph-loader').addClass('hidden');
      $this.find('.ph-addtocart').removeClass('hidden');
      $this.find('.ph-addtocart').attr('disabled', false);
      $this.find('.ph-addtocart').removeClass('out-of-stock ph-disabledbutton ph-featuredproduct__outOfStock');
      $this.find('.ph-addtocart').prop('type', 'submit').attr(ariaDisabled, false);
      $this.find('.ph-freqorderedproduct__jcarousel .ph-addtocart').text(ACC.config.addToCart);
      ACC.pdp.igtdMessageDisplay(result.code);
    } else {
      $this.find('.ph-loader').addClass('hidden');
      $this.find('.' + addtocartButton).removeClass('hidden');
      $this.find('.ph-addtocart').removeClass('hidden');
    }
  }

  function lazyLoadFeaturedProductHhsResponse(results) {
    results.forEach(function(result) {
      $(componentproductlist).each(function() {
        var $this = $(this),
            ctn = $this.find(prodSearchName).attr('data-ctn'),
            salesOrg = $this.find(prodSearchName).attr('data-salesOrg'),
            finalPriceClass = featureFinalPriceHhsClass;

        if (isOneStore === 'true' && $this.find(featureFinalPricePcmsClass).length > 0) {
          finalPriceClass = featureFinalPricePcmsClass;
        }

        if (result.code === ctn && isOneStore !== 'true') {
          lazyLoadFeaturedProductHhsSubFunction(result, $this, finalPriceClass);
        }

        if (result.code === ctn && result.salesOrg === salesOrg && isOneStore === 'true') {
          lazyLoadFeaturedProductHhsSubFunction(result, $this, finalPriceClass);
        }
      });
    });
  }

  function lazyLoadFeaturedProductHhs() {
    var prodList = [],
        dataObj = {},
        priceUrl = '/lazyload/gethhspricedata',
        contentType = 'application/x-www-form-urlencoded';

    $(componentproductlist).each(function() {
      prodList.push($(this).find(prodSearchName).attr('data-ctn'));
    });
    dataObj = {
      codes: prodList.toString()
    };

    if (isOneStore === 'true') {
      var productList = [];

      priceUrl = '/lazyload/getPriceList';
      $(componentproductlist).each(function() {
        var currObj = {
          salesOrg: ''
        };

        currObj.salesOrg = $(this).find(prodSearchName).attr('data-salesorg');
        currObj.code = $(this).find(prodSearchName).attr('data-ctn');
        productList.push(currObj);
      });
      contentType = 'application/json';
      dataObj = {
        productList: productList
      };
      dataObj = JSON.stringify(dataObj);
    }

    $.ajax({
      type: 'POST',
      url: ACC.config.contextPath + priceUrl,
      contentType: contentType,
      dataType: 'json',
      data: dataObj,
      success: function(results) {
        lazyLoadFeaturedProductHhsResponse(results);
      }
    });
  }

  function oneStorePriceCallMainFunction() {
    if ($(finalPricePcmsClass).length > 0 || $(finalPriceHhsClass).length > 0) {
      lazyLoadListingPageHhs();
    }

    if ($(featureFinalPricePcmsClass).length > 0 || $(featureFinalPriceHhsClass).length > 0) {
      lazyLoadFeaturedProductHhs();
    }
  }

  function onLoadPriceCallMainFunction() {
    if ($(finalPricePcmsClass).length > 0) {
      lazyLoadListingPage();
    }

    if ($(finalPriceHhsClass).length > 0) {
      lazyLoadListingPageHhs();
    }

    if ($(featureFinalPricePcmsClass).length > 0) {
      lazyLoadFeaturedProduct();
    }

    if ($(featureFinalPriceHhsClass).length > 0) {
      lazyLoadFeaturedProductHhs();
    }
  }

  window.addEventListener('DOMContentLoaded', function() {
    if (isOneStore === 'true') {
      oneStorePriceCallMainFunction();
    } else {
      onLoadPriceCallMainFunction();
    }
  });
})();

/* eslint-enable complexity */
/* eslint-enable require-jsdoc */
